import { Link } from 'react-router-dom'
import TextSearch from '../components/TextSearch'
import './TextSearchPage.css'

/**
 * Text Search Page
 *
 * A dedicated page for free text search of affiliate products.
 */
const TextSearchPage = () => {
  return (
    <div className="text-search-page">
      <div className="text-search-page-nav">
        <Link to="/search" className="back-to-visual-link">
          ← Visual Search
        </Link>
      </div>
      <TextSearch />
    </div>
  )
}

export default TextSearchPage
